import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {BsLinkedin} from 'react-icons/bs'
import {useRef, useState} from 'react';

const Contact = () => {
    const form = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success', 'error', or ''

    const sendEmail = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        setMessage('Sending...');
        setMessageType('');

        try {
            const formData = new FormData(event.target);
            
            // Add Web3Forms access key
            const accessKey = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;
            
            // Check if access key is configured
            if (!accessKey || accessKey === 'YOUR_WEB3FORMS_ACCESS_KEY') {
                console.error('Web3Forms access key not configured');
                setMessage('Contact form is temporarily unavailable. Please contact me directly via email.');
                setMessageType('error');
                setIsLoading(false);
                return;
            }
            
            formData.append('access_key', accessKey);
            
            const response = await fetch('https://api.web3forms.com/submit', {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.success) {
                setMessage('Message sent successfully! I\'ll get back to you soon.');
                setMessageType('success');
                event.target.reset();
            } else {
                // Log actual error for debugging but show generic message to user
                console.error('Form submission failed:', data);
                setMessage('Unable to send message at this time. Please try again or contact me directly via email.');
                setMessageType('error');
            }
        } catch (error) {
            // Log actual error for debugging but show generic message to user
            console.error('Network error:', error);
            setMessage('Unable to send message at this time. Please try again or contact me directly via email.');
            setMessageType('error');
        } finally {
            setIsLoading(false);
        }
    };

    const contactEmail = 'akiofujita0@gmail.com';

    return (
        <section id='contact'>
            <h5>Get In Touch</h5>
            <h2>Contact Me</h2>

            <div className="container contact__container">
                <div className="contact__options">
                    <article className='contact__option'>
                        <MdOutlineEmail className='contact__option-icon'/>
                        <h4>Email</h4>
                        <h5>{contactEmail}</h5>
                        <a href={`mailto:${contactEmail}`} target='_blank' rel="noreferrer">Send a Message</a>
                    </article>

                    <article className='contact__option'>
                        <BsLinkedin className='contact__option-icon'/>
                        <h4>Linkedin</h4>
                        <a href='https://www.linkedin.com/in/akiofujita/' target='_blank' rel="noreferrer">Send a Message</a>
                    </article>
                </div>

                <form ref={form} onSubmit={sendEmail}>
                    <input type='text' name='name' placeholder='Your Full Name' required disabled={isLoading}/>
                    <input type='email' name='email' placeholder='Your Email' required disabled={isLoading}/>
                    <textarea name='message' rows='7' placeholder='Your Message' required disabled={isLoading}></textarea>
                    
                    {/* Hidden fields for Web3Forms */}
                    <input type="hidden" name="subject" value="New Contact Form Submission from Portfolio" />
                    <input type="hidden" name="from_name" value="Portfolio Contact Form" />
                    
                    {message && (
                        <div className={`contact-message ${messageType}`}>
                            {message}
                        </div>
                    )}
                    
                    <div className='contact-btn-container'>
                        <button 
                            type='submit' 
                            className='btn btn-primary' 
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <>
                                    <span className="contact-loading-spinner"></span>
                                    Sending...
                                </>
                            ) : 'Send Message'}
                        </button>
                    </div>
                </form>
            </div>
        </section>
    )
}

export default Contact
